var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 30,
    viewBox: "0 0 15 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.65 6.48357H14.51V0.503569H10.06C9.63 0.483569 4.33 0.383569 2.96 5.62357C2.94 5.67357 2.5 6.91357 2.5 9.83357L0 9.84357V16.0836L2.51 16.0736V29.7936H9.79V16.0736H13.1V9.82357H9.79V8.85357C9.79 7.77357 9.49 6.48357 11.65 6.48357ZM11.9 11.0336V14.8736H8.58V28.5736H3.71V14.8536L1.2 14.8736V11.0436L3.72 11.0336L3.71 10.4136C3.65 7.33357 4.09 6.04357 4.11 5.98357C5.3 1.47357 9.82 1.70357 10.01 1.71357H13.31V5.29357H11.65C8.83 5.29357 8.58 7.13357 8.58 8.85357V11.0336H11.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.542ffa41c9063c778486a81f733b3477.svg";
export { ForwardRef as ReactComponent };